var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUnfold = function SvgUnfold(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 116 15"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#unfold_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#CBCBCB",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M115.13 1.13 60.325 14.231a10 10 0 0 1-4.65 0L.87 1.13"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "unfold_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M-117.5 0h370v16h-370z"
  })))));
};
export default SvgUnfold;